<template>
	<div class="o-dashboard">

		<div class="o-dashboard__breadcrumbs">
			<ul class="c-breadcrumbs">
				<li>
					<a href="/leveringen">Leveringen</a>
				</li>
				<li>
					<span>{{ deliveries.order_number }}</span>
				</li>
			</ul>
		</div>

		<div class="o-dashboard__panels">
			<div class="row collapse">

				<div class="column small-12 xlarge-8" v-if="deliveries.client">

					<div v-if="deliveries.delivery_type_id === $constants.delivery.BULK_LEVERING && productList">
						<c-block-delivery-info :delivery="deliveries" :productList="productList"></c-block-delivery-info>
					</div>
					<div v-else>
						<c-block-delivery-info :delivery="deliveries"></c-block-delivery-info>
					</div>
				</div>

				<div class="column small-12 xlarge-4">

					<c-block-complete v-if="(deliveries.finished || deliveries.delivery_type_id === $constants.delivery.UITDIENST || deliveries.delivery_type_id === $constants.delivery.REPARATIE || deliveries.delivery_type_id === $constants.delivery.EOL_SWAP) && deliveries && deliveries.carrier_id == $constants.carrier.REUZADO"
						:delivery="delivery"
						ref="completeDelivery">
					</c-block-complete>

				</div>
			</div>
			<div class="row" v-if="!deliveryIsCancelled">
				<div class="margin-b-24" v-if="items.length > 0">
					<button type="button" class="c-btn c-btn--hollow no-margin" @click="print({ printable: 'printJS-form', type: 'html', targetStyles: ['*'], onError: () => {}  })">
						Print pakbon
					</button>
				</div>
				<div v-if="deliveries.carrier_id == $constants.carrier.POSTNL">
				<button type="button" class="c-btn c-btn--hollow no-margin" @click="print({printable:'/deliveries/' + deliveries.id + '/shipping_label', type:'pdf', showModal:true, modalMessage: 'Label inladen...'})">
					Print label
				</button>
				</div>
			</div>
			<object :data="'/deliveries/' + deliveries.id + '/shipping_label'" type="application/pdf" style="display:none;">Pakbon</object>

			<div class="row collapse" v-if="deliveries.completed === null ">

				<div class="column small-12 xlarge-8" v-if="deliveries.delivery_type_id === $constants.delivery.REPARATIE || deliveries.delivery_type_id === $constants.delivery.INDIENST || deliveries.delivery_type_id === $constants.delivery.UITDIENST || deliveries.delivery_type_id === $constants.delivery.EXTRA_PRODUCTEN || deliveries.delivery_type_id === $constants.delivery.EOL_SWAP || deliveries.delivery_type_id === $constants.delivery.BULK_LEVERING || deliveries.delivery_type_id === $constants.delivery.BACKORDER">

					<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
						<h4>Artikelen</h4>

						<c-table v-if="productList && deliveries.delivery_type_id === $constants.delivery.BULK_LEVERING"
							:columns="bulkColumns"
							:testRows="productList"
							:search="false">
						</c-table>

						<c-table v-else-if="items"
							:columns="columns"
							:testRows="items"
							:search="false">
						</c-table>

						<div class="c-stock__button flex flex-center margin-t-24" v-if="!deliveries.complete && !deliveryIsCancelled">
							<button @click="openModalAddPrenotification" class="c-btn c-btn--hollow no-margin">
								Artikelen uitklaren
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<c-add-prenotification v-if="deliveries.delivery_type_id === $constants.delivery.BULK_LEVERING && productList"
			v-show="modalAddPrenotification"
			@close="closePrenotification()"
			@open-modal-scan-prenotification="openModalScanPrenotification"
			@get-data="getData"
			@added="load"
			:size="'medium'"
			:products="productList"
			:uitklaren="true"
			:bulk="true"
			:delivery_id="deliveries.id">
		</c-add-prenotification>

		<c-add-prenotification v-else-if="deliveries.products || deliveries.delivery_type_id ===! $constants.delivery.BULK_LEVERING && deliveries.delivery_type_id ===! $constants.delivery.UITDIENST "
			v-show="modalAddPrenotification"
			@close="closePrenotification()"
			@open-modal-scan-prenotification="openModalScanPrenotification"
			@get-data="getData"
			@added="load"
			:size="'medium'"
			:products="products"
			:uitklaren="true"
            :delivery_id="deliveries.id">
		</c-add-prenotification>

		<c-scan-prenotification v-if="deliveries.products || deliveries.delivery_type_id ===! $constants.delivery.UITDIENST || product"
			v-show="modalScanPrenotification"
			@close="modalScanPrenotification=false"
			@open-modal-add-prenotification="openModalAddPrenotification"
			@open-modal-scan-bulk="openModalScanBulk"
			ref="scanPrenotification"
			:size="'medium'"
			:product="product">
		</c-scan-prenotification>

		<c-finish-delivery v-if="deliveries"
			ref="finishDelivery"
			:delivery="deliveries"
			v-show="modal"
			@close="modal=false"
			:size="'medium'"
			@added="load">
		</c-finish-delivery>

		<c-new-resignation v-if="deliveries.delivery_type_id === $constants.delivery.UITDIENST"
			:addresses="deliveryAddresses"
			:contacts="deliveries.client.contacts"
			:contact="deliveries.client_id"
			:items="deliveries.client.items"
			v-show="modalResignation"
			@close="modalResignation=false"
			@added="load"
			:edit="true"
			:delivery="deliveries"
			:title="'Uitdiensttreding wijzigen'"
			:size="'medium'">
		</c-new-resignation>

		<c-repair-request v-if="deliveries.delivery_type_id === $constants.delivery.REPARATIE"
			v-show="modalRepair"
			:items="deliveries.client.client_type_id == 2 ? deliveries.client.items : deliveries.items"
			:addresses="deliveryAddresses"
			:parent_client_id="deliveries.client.parent_client_id"
			:client_id="deliveries.client_id"
			:edit="true"
			:delivery="deliveries"
			@close="modalRepair=false"
			@added="load"
			:size="'medium'">
		</c-repair-request>

		<c-edit-new-end-user v-if="deliveries.delivery_type_id === $constants.delivery.INDIENST"
			v-show="modalNewReseller"
			:addresses="deliveryAddresses"
			:delivery="deliveries"
			:edit="true"
			:size="'medium'"
			@close="modalNewReseller=false"
			@added="load">
		</c-edit-new-end-user>

		<c-eol-swap v-if="deliveries.delivery_type_id === $constants.delivery.EOL_SWAP"
			v-show="modalEol"
			:items="deliveries.client.client_type_id == 2 ? deliveries.client.items : deliveries.items"
			:addresses="deliveryAddresses"
			:parent_client_id="deliveries.client.parent_client_id"
			:client_id="deliveries.client_id"
			:edit="true"
			:delivery="deliveries"
			@close="modalEol=false"
			@added="load"
			:size="'medium'">
		</c-eol-swap>

		<c-order-extra-products v-if="deliveries.delivery_type_id === $constants.delivery.EXTRA_PRODUCTEN"
			v-show="modalExtraProducts"
			:addresses="deliveryAddresses"
			:client="deliveries.client"
			:delivery="deliveries"
			:edit="true"
			@close="modalExtraProducts=false"
			@added="load"
			:size="'medium'">
		</c-order-extra-products>

		<c-bulk-order v-if="deliveries.delivery_type_id === $constants.delivery.BULK_LEVERING && productList"
			v-show="modalBulkOrder"
			:client="deliveries.client"
			:delivery="deliveries"
			:productList="productList"
			:edit="true"
			@close="modalBulkOrder=false"
			@added="load"
			:size="'medium'">
		</c-bulk-order>

		<c-change-carrier v-if="deliveries"
			v-show="changeCarrier"
			@close="changeCarrier=false"
			@added="load"
			:size="'small'"
			:delivery="deliveries">
		</c-change-carrier>

		<c-scan-bulk
			v-show="modalScanBulk"
			:size="'medium'"
			@close="modalScanBulk=false"
			@added="handleBulkScan">
		</c-scan-bulk>  

	</div>

	<div style="height:0;overflow-x:hidden;overflow-y:hidden;max-width:680px;" v-if="deliveries.delivery_type_id === $constants.delivery.BULK_LEVERING && productList">
		<c-shipping-list v-if="deliveries && items" id="printJS-form"
			:deliveries="deliveries"
			:items="items"
			:productList="productList">
		</c-shipping-list>
	</div>
	<div style="height:0;overflow-x:hidden;overflow-y:hidden;max-width:680px;" v-else>
		<c-shipping-list v-if="deliveries && items" id="printJS-form"
			:deliveries="deliveries"
			:pickupItems="pickupItems"
			:items="items">
		</c-shipping-list>
	</div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import { ValidationError } from '@app/errors';
import 'print-js';

import CBreadcrumbs from '@components/Breadcrumbs';
import CBlockDeliveryInfo from '@components/blocks/DeliveryInfo';
import CBlockComplete from '@components/blocks/Complete';
import CBlockActivity from '@components/blocks/Activity';
import CBlockActivities from '@components/blocks/Activities';
import CTable from '@components/table/Table';
import CShippingList from '@components/blocks/ShippingList';

import CFinishDelivery from '@app/modals/FinishDelivery';
import CRepairRequest from '@app/modals/RepairRequest';
import CNewResignation from '@app/modals/NewResignation';
import CAddPrenotification from '@app/modals/AddPrenotification';
import CScanPrenotification from '@app/modals/ScanPrenotification';
import CEditNewEndUser from '@app/modals/EditNewEndUser';
import CEolSwap from '@app/modals/EolSwap';
import COrderExtraProducts from '@app/modals/OrderExtraProducts';
import CChangeCarrier from '@app/modals/ChangeCarrier';
import CBulkOrder from '@app/modals/BulkOrder';
import CScanBulk from '@app/modals/ScanBulk';


export default {
	mixins: [ View, Form ],
	components: {
		CTable,
		CBreadcrumbs,
		CBlockDeliveryInfo,
		CBlockComplete,
		CBlockActivity,
		CBlockActivities,
		CEolSwap,
		CFinishDelivery,
		CEditNewEndUser,
		CRepairRequest,
		CNewResignation,
		CAddPrenotification,
		CScanPrenotification,
		COrderExtraProducts,
		CShippingList,
		CChangeCarrier,
		CBulkOrder,
		CScanBulk
	},
	data() {
		return {
			modal: false,
			modalEol: false,
			modalNewReseller: false,
			deliveries: '',
			delivery_modal: false,
			modalResignation: false,
			modalRepair: false,
			modalAddPrenotification: false,
			modalScanPrenotification: false,
			modalExtraProducts: false,
			changeCarrier: false,
			modalBulkOrder: false,
			modalScanBulk: false,
			contact: '',
			items: [],
			pickupItems: [],
			product: '',
			products: [],
			productList: [],
			scannedBulkItems: []
		}
	},
	methods: {
		print() {
			return window.printJS(...arguments);
		},
		openModal() {
			this.modal = true;
		},
		openModalEol() {
			this.modalEol = true;
		},
		openDeliveryModal(){
			this.delivery_modal = true
		},
		openModalChangeCarrier(){
			this.changeCarrier = true
		},
		openModalExtraProducts() {
			this.modalExtraProducts = true;
		},
		openModalResignation() {
			this.modalResignation = true;
		},
		openrepairRequest(){
			this.modalRepair = true;
		},
		openNewReseller(){
			this.modalNewReseller = true;
		},
		openModalAddPrenotification() {
			this.modalAddPrenotification = true;
		},
		openModalScanPrenotification() {
			this.modalScanPrenotification = true;
			this.modalAddPrenotification = false;
		},
		openModalBulkOrder(){
			this.modalBulkOrder = true;
		},
		openModalScanBulk(){
			this.modalScanBulk = true;
		},
		handleBulkScan(items) {
			this.$refs.scanPrenotification.addBulk(items);
		},
        cancelDelivery(){
            this.$xhr.post('/api/delivery/cancel', {id: this.$route.params.id}).then( ( {result}) => {
                this.load();
                this.$store.dispatch('toast/success', {title: 'Levering annuleren', text: 'De levering is geannuleerd'});
            }).catch( (e) => {
                if (e instanceof ValidationError) {
                    this.$refs.form.setErrors(e.errors);
                }
                this.$store.dispatch('toast/alert', {title: 'Levering annuleren', text: 'Er is helaas iets fout gegaan bij het annuleren van de levering'});
            });
        },
        reopenCancelledDelivery(){
            this.$xhr.post('/api/delivery/reopen-cancelled-delivery', {id: this.$route.params.id}).then( ( {result}) => {
                this.load();
                this.$store.dispatch('toast/success', {title: 'Levering heropenen', text: 'De levering is heropend'});
            }).catch( (e) => {
                if (e instanceof ValidationError) {
                    this.$refs.form.setErrors(e.errors);
                }
                this.$store.dispatch('toast/alert', {title: 'Levering heropenen', text: 'Er is helaas iets fout gegaan bij het heropenen van de levering'});
            });
        },
        deleteDelivery() {
            this.$xhr.post('/api/delivery/delete', {id: this.$route.params.id}).then( ( {result}) => {
                this.$router.push('/leveringen')
                this.$store.dispatch('toast/success', {title: 'Levering verwijderen', text: 'De levering is verwijderd'});
            }).catch( (e) => {
                if (e instanceof ValidationError) {
                    this.$refs.form.setErrors(e.errors);
                }
                this.$store.dispatch('toast/alert', {title: 'Levering verwijderen', text: 'Er is helaas iets fout gegaan bij het verwijderen van de levering'});
            });
        },
		getData(e){
			this.product = e;
		},
		closePrenotification(){
			this.modalAddPrenotification = false;
		},
		load() {
			this.$xhr.get('/api/deliveries/' + this.$route.params.id)
				.then( ({result}) => {
					this.deliveries = result;
					let count = 0;
					this.items = [];
					this.pickupItems = [];
                    this.products = [];
					this.productList = [];
					let expected;
					let arrived;

					for(const product of this.deliveries.products)
					{
						if(this.deliveries.delivery_type_id === this.$constants.delivery.BULK_LEVERING){

							if(this.productList.find(elem => elem.id === product.id)){

								arrived = product.pickup.item_id == null ? arrived : (arrived + 1);
								let index = this.productList.indexOf(this.productList.find(elem => elem.id === product.id));
								expected++;
								this.productList[index] = {name: product.name, article_number: product.article_number, id: product.id, expected: expected, arrived: arrived, product_group_id: product.product_group_id};
							}
							else {
								expected = 1;
								arrived = product.pickup.item_id == null ? 0 : 1;
								this.productList.push({name: product.name, article_number: product.article_number, id: product.id, expected: expected, arrived: arrived, product_group_id: product.product_group_id});

							}
						}

						if( product.pickup.is_pickup === 0){
							if(product.pickup.item_id === null){
								product.status = "open";
								this.products.push(product);
								count++;
							}
							else {
								product.status = "Uitgeklaard";
								product.serial = this.deliveries.items.find(item => item.id === product.pickup.item_id).serial
							}

							this.items.push(product);
						}
						else{
							this.pickupItems.push(product);
						}
					}

					if(this.$refs.finishDelivery){
						this.$refs.finishDelivery.products(this.deliveries);
					}

					if(this.$refs.completeDelivery){
						this.$refs.completeDelivery.load(this.deliveries);
					}

				})
				.catch((e) => {
					this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Leveringen kunnen niet worden ingeladen'});
				});
		}
	},
	computed: {
		columns() {
			return [
				{ name: 'name', label: 'Artikelomschrijving'},
				{ name: 'article_number', label: 'Artikelnummer' },
				{ name: 'serial', label: 'Serienummer' },
				{ name: 'status', label: 'Status' }
			];
		},
		bulkColumns(){
			return [
				{ name: 'name', label: 'Artikelomschrijving' },
				{ name: 'article_number', label: 'Artikelnummer' },
				{ name: 'expected', label: 'Aantal' },
				{ name: 'arrived', label: 'Uitgeklaard' }
			];
		},
		deliveryAddresses() {
			return [...this.deliveries.client.addresses ?? [], ...this.deliveries.client.parent?.addresses ?? []];
		},
        deliveryIsCancelled() {
            return this.deliveries.is_cancelled;
        },
		delivery(){
			return this.deliveries;
		},
	},
	created() {
		this.$store.dispatch('listener/on', {
			event: 'eol-swap',
			listener: this.openModalEol
		});

		this.$store.dispatch('listener/on', {
			event: 'change-carrier',
			listener: this.openModalChangeCarrier
		});

		this.$store.dispatch('listener/on', {
			event: 'extra-products',
			listener: this.openModalExtraProducts
		});

		this.$store.dispatch('listener/on', {
			event: 'finish-delivery',
			listener: this.openModal
		});

		this.$store.dispatch('listener/on', {
			event: 'new-reseller',
			listener: this.openNewReseller
		});

		this.$store.dispatch('listener/on', {
			event: 'repair',
			listener: this.openrepairRequest
		});

		this.$store.dispatch('listener/on', {
			event: 'resignation',
			listener: this.openModalResignation,

		});this.$store.dispatch('listener/on', {
			event: 'add-prenotification',
			listener: this.openModalAddPrenotification
		});

		this.$store.dispatch('listener/on', {
			event: 'scan-prenotification',
			listener: this.openModalScanPrenotification
		});

		this.$store.dispatch('listener/on', {
			event: 'bulk-order',
			listener: this.openModalBulkOrder
		});

		this.$store.dispatch('listener/on', {
			event: 'scan-bulk',
			listener: this.openModalScanBulk
		});

        this.$store.dispatch('listener/on', {
            event: 'cancel-delivery',
            listener: this.cancelDelivery
        });

        this.$store.dispatch('listener/on', {
            event: 'reopen-cancelled-delivery',
            listener: this.reopenCancelledDelivery
        });

        this.$store.dispatch('listener/on', {
            event: 'delete-delivery',
            listener: this.deleteDelivery
        });

	},
    beforeUnmount() {
		this.$store.dispatch('listener/off', {
			event: 'add-prenotification',
			listener: this.openModalAddPrenotification
		});
		this.$store.dispatch('listener/off', {
			event: 'eol-swap',
			listener: this.openModalChangeCarrier
		});
		this.$store.dispatch('listener/off', {
			event: 'extra-products',
			listener: this.openModalExtraProducts
		});
		this.$store.dispatch('listener/off', {
			event: 'eol-swap',
			listener: this.openModalEol
		});
		this.$store.dispatch('listener/off', {
			event: 'scan-prenotification',
			listener: this.openModalScanPrenotification
		});
		this.$store.dispatch('listener/off', {
			event: 'finish-delivery',
			listener: this.openModal
		});
		this.$store.dispatch('listener/off', {
			event: 'repair',
			listener: this.openrepairRequest
		});
			this.$store.dispatch('listener/off', {
			event: 'resignation',
			listener: this.openModalResignation
		});
		this.$store.dispatch('listener/off', {
			event: 'new-reseller',
			listener: this.openNewReseller
		});
		this.$store.dispatch('listener/off', {
			event: 'bulk-order',
			listener: this.openModalBulkOrder
		});
		this.$store.dispatch('listener/off', {
			event: 'scan-bulk',
			listener: this.openModalScanBulk
		});
        this.$store.dispatch('listener/off', {
            event: 'cancel-delivery',
            listener: this.cancelDelivery
        });
        this.$store.dispatch('listener/off', {
            event: 'reopen-cancelled-delivery',
            listener: this.reopenCancelledDelivery
        });
        this.$store.dispatch('listener/off', {
            event: 'delete-delivery',
            listener: this.deleteDelivery
        });
	},
	mounted(){
		this.load();
	}
}
</script>
